import { queryClient, send } from "../fetch";
import type { CreateMultiUserPlanOrderResponseProto } from "@noom/noom-contracts/noom_contracts/growth/orders/growth_orders_service";

type ProratedRefundDataResponse = {
  refundAmount: number;
  refundCurrency: string | null;
};

export type MultiUserPlanPeerResponse = {
  accessCode?: string;
  upid: string;
  isPrimaryUser: boolean;
  profileName?: string;
};

export const GET_PRORATED_REFUND_DATA_CACHE_KEY = ["proratedRefundData"];
export const GET_PEERS_CACHE_KEY = ["getPeers"];

export function getProratedRefundData(
  includePremiumAddon: boolean,
  subscriptionId?: string
): Promise<ProratedRefundDataResponse> {
  let url = `/api/plans/proratedRefundData?includePremiumAddon=${
    includePremiumAddon ? "true" : "false"
  }`;
  if (subscriptionId) {
    url += `&subscriptionId=${subscriptionId}`;
  }
  return send("GET", url);
}

export function getPeers(): Promise<MultiUserPlanPeerResponse[]> {
  return send("GET", "/api/multiUserPlans/peers");
}

export async function getMultiUserPlanOrder(
  multiUserPlanId: string,
  secondaryEmail: string,
  secondaryName?: string
): Promise<CreateMultiUserPlanOrderResponseProto> {
  const body = {
    multiUserPlanId,
    secondaryEmail,
    ...(secondaryName && { secondaryName }),
  };

  return send("POST", "/api/multiUserPlans/v1/createOrder/", body);
}

export async function loadPeers() {
  return queryClient.prefetchQuery(GET_PEERS_CACHE_KEY, getPeers, { retry: 3 });
}
